import { render, staticRenderFns } from "./PeriodTable.vue?vue&type=template&id=649faa88&scoped=true"
import script from "./PeriodTable.vue?vue&type=script&lang=js"
export * from "./PeriodTable.vue?vue&type=script&lang=js"
import style0 from "./PeriodTable.vue?vue&type=style&index=0&id=649faa88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649faa88",
  null
  
)

export default component.exports